import { API_URL } from "network/http/api";
import React from "react";

const Image = ({ className, src, alt }) => {
    let url = API_URL + "/file/image/" + src
    return <img src={url} alt={alt} className={className} />
}

export default Image